import axios from "axios";
import { CSRF_COOKIE_NAME } from "./constants";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const apiClient = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Super Admin "view-as" preview: while set, requests carry this short-lived Bearer token,
// which the backend prefers over the (untouched) super-admin session cookie.
let previewToken = null;
export function setPreviewToken(token) {
  previewToken = token || null;
}
export function getPreviewToken() {
  return previewToken;
}

function readCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

apiClient.interceptors.request.use((config) => {
  if (previewToken) {
    config.headers["Authorization"] = `Bearer ${previewToken}`;
  }
  const method = (config.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    const token = readCookie(CSRF_COOKIE_NAME);
    if (token) {
      config.headers["X-CSRF-Token"] = token;
    }
  }
  return config;
});

apiClient.interceptors.response.use(
  (r) => r,
  (error) => {
    // If a preview token expires mid-session, drop it so the app reverts to the admin session.
    if (error.response?.status === 401 && previewToken) {
      previewToken = null;
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
